import SEO from './SEO'
import Facebook from './Facebook'
import Twitter from './Twitter'

export { Facebook, Twitter }

export default SEO
